module.exports = __webpack_public_path__ + "ef25e20ca2151abacf9a9915eb9cb934.svg";